
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function BookPunetoganpatipulecab() {



    const cardData =
    {
        keyword: 'Pune to Ganpatipule Taxi Services',
        heading: 'S9 Travels: Pune to Ganpatipule Taxi Services ',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Ganpatipule. Whether you are planning a beach holiday, a religious visit, or a nature retreat, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Ganpatipule is approximately 330 km from Pune, and the journey takes around 6 to 7 hours by road. Enjoy a safe and comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Ganpatipule with S9 Travels',

"topPlaces": [
    {
        "title": "Ganpatipule Temple",
        "description": "The Ganpatipule Temple is a significant pilgrimage site dedicated to Lord Ganesha. Known for its ancient Swayambhu (self-originated) idol of Lord Ganesha, this temple is located near the picturesque Ganpatipule Beach. It attracts thousands of devotees every year and is one of the most sacred places in the Konkan region."
    },
    {
        "title": "Ganpatipule Beach",
        "description": "Famous for its serene and untouched beauty, Ganpatipule Beach is an ideal destination for those seeking peace and relaxation. The golden sand, clear waters, and peaceful surroundings make it perfect for a leisurely stroll, swimming, or beach picnics."
    },
    {
        "title": "Jaigad Fort",
        "description": "A historic fort located near Ganpatipule, Jaigad Fort offers magnificent views of the Arabian Sea. Built by the Marathas, the fort provides insight into the region's rich history and offers a serene atmosphere to explore. The area is perfect for history enthusiasts and nature lovers alike."
    },
    {
        "title": "Malgund Beach",
        "description": "A quieter alternative to Ganpatipule Beach, Malgund Beach is ideal for travelers seeking solitude and tranquility. This pristine beach is less crowded and surrounded by lush greenery, making it a perfect spot for relaxation and enjoying nature."
    },
    {
        "title": "Aare Ware Beach",
        "description": "A hidden gem of the Konkan coastline, Aare Ware Beach is a pristine, unspoiled beach near Ganpatipule. Known for its natural beauty and less commercialized environment, it is ideal for a peaceful day out with stunning views of the sea and hills."
    },
    {
        "title": "Ratnagiri Fort",
        "description": "Located around 30 km from Ganpatipule, Ratnagiri Fort is a historical fort offering magnificent views of the surrounding area. The fort has historical importance as it was used by the Marathas and is now a popular tourist destination. The scenic landscapes from the fort are perfect for photography enthusiasts."
    },
    {
        "title": "Bhatye Beach",
        "description": "Bhatye Beach is a quiet and less crowded beach located near Ratnagiri. It is ideal for a relaxing getaway with the sound of gentle waves and a tranquil atmosphere. The beach is also known for its views of the sunset, making it a popular spot for evening walks."
    },
    {
        "title": "Shri Gajaban Maharaj Ashram",
        "description": "Situated in the hills near Ganpatipule, this ashram is a peaceful retreat for spiritual seekers. It offers a serene atmosphere and beautiful surroundings to meditate, relax, and reflect. Visitors can also explore the natural beauty of the surrounding hills and forests."
    },
    {
        "title": "Swayambhu Ganapati",
        "description": "This ancient temple is located in a cave-like structure near the Ganpatipule beach. The Swayambhu Ganapati idol is one of the most revered deities in the region. This temple is known for its peaceful and spiritual vibe, providing devotees with a calm and fulfilling experience."
    },
    {
        "title": "Tidal Waves Beach",
        "description": "Tidal Waves Beach is located on the way to Ganpatipule and is perfect for a scenic drive. It offers clear water, cool winds, and a quiet atmosphere, making it a great spot for a peaceful beach outing. The area is often less crowded, ensuring a calm and relaxing experience."
    }
],

"services": [
  {
    "name": "Pune to Ganpatipule Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Ganpatipule. Whether you're traveling for relaxation, spiritual purposes, or a leisure trip, enjoy a smooth, hassle-free ride with us. Book your Pune to Ganpatipule taxi today!"
  },
  {
    "name": "Pune to Ganpatipule Cab Service",
    "description": "Choose S9 Travels for a professional and dependable cab service from Pune to Ganpatipule. Our experienced drivers and well-maintained vehicles ensure that you enjoy a comfortable and pleasant journey."
  },
  {
    "name": "Pune to Ganpatipule One-Way Taxi",
    "description": "S9 Travels provides affordable one-way taxi services from Pune to Ganpatipule. Whether you're traveling for a quick visit or planning to stay, we offer a convenient, direct ride to your destination without any hassle."
  },
  {
    "name": "Pune to Ganpatipule Round Trip",
    "description": "For a round trip from Pune to Ganpatipule, S9 Travels provides flexible and reliable options. Our round trip service ensures that your journey is comfortable, timely, and hassle-free, whether for business or leisure."
  },
  {
    "name": "Pune to Ganpatipule Taxi Fare",
    "description": "S9 Travels offers transparent and affordable taxi fares for your Pune to Ganpatipule journey. Our pricing is competitive, ensuring that you get the best value with no hidden charges. Get an upfront fare estimate for a stress-free travel experience."
  },
  {
    "name": "Pune to Ganpatipule Car Rental",
    "description": "Looking for a car rental for your trip from Pune to Ganpatipule? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles for a comfortable and personalized journey."
  },
  {
    "name": "Pune to Ganpatipule Drop Taxi",
    "description": "Need a one-way drop from Pune to Ganpatipule? S9 Travels offers reliable drop taxi services to make your journey stress-free and convenient. Our drivers ensure that you reach your destination on time and in comfort."
  },
  {
    "name": "Pune to Ganpatipule Luxury Taxi",
    "description": "For a premium travel experience, S9 Travels offers luxury taxi services for your Pune to Ganpatipule trip. Enjoy enhanced comfort, extra space, and smooth travel with our luxury vehicles and professional drivers."
  },
  {
    "name": "Pune to Ganpatipule Efficient Taxi",
    "description": "S9 Travels provides Efficient Taxi services for those seeking a budget-friendly travel option from Pune to Ganpatipule. Share the ride with others and enjoy the comfort and convenience of a professional taxi service at an affordable price."
  }
],


"tableData": [
  ["Book Pune To Ganpatipule Taxi", "Book Pune To Ganpatipule Cab Service"],
  ["Book Pune To Ganpatipule One-Way Taxi", "Book Pune To Ganpatipule Round Trip"],
  ["Book Pune To Ganpatipule Taxi Fare", "Book Pune To Ganpatipule Car Rental"],
  ["Book Pune To Ganpatipule Drop Taxi", "Book Pune To Ganpatipule Luxury Taxi"],
  ["Book Pune To Ganpatipule Efficient Taxi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand that time is valuable when traveling from Pune to Ganpatipule. Whether you're heading to a serene beach getaway or a spiritual visit, our drivers ensure timely pickups and drop-offs, ensuring your journey is smooth and hassle-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of comfortable and well-maintained vehicles for your journey to Ganpatipule. With spacious interiors, air conditioning, and plush seating, we provide a relaxed and enjoyable ride throughout the trip."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes to Ganpatipule and ensure a safe and comfortable journey. They prioritize your safety and comfort, making sure you reach your destination smoothly."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Ganpatipule trip. We have no hidden charges and provide a clear breakdown of costs, so you know exactly what to expect."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure and peaceful ride to Ganpatipule."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "We operate 24/7 to cater to your travel needs, whether you're planning an early morning trip or a late-night return from Ganpatipule. Our customer service team is available at all times to assist you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Ganpatipule cab with S9 Travels is easy. You can book online through our website or mobile app, or you can reach out to our customer service team for personalized assistance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you’re visiting Ganpatipule for leisure, a pilgrimage, or relaxation, we offer customized travel packages tailored to your specific preferences and requirements. Let us know your needs, and we’ll make your trip special."
  }
]








    }




    const faqData = [
        [
          {
            question: 'How can I book a Pune to Ganpatipule cab with S9 Travels?',
            answer: 'Booking is simple! You can book a cab through our website or mobile app, or contact our customer service team for help with your booking.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly experienced and skilled in handling long-distance travel, ensuring a safe and smooth journey to Ganpatipule.',
          },
          {
            question: 'What types of vehicles are available for Pune to Ganpatipule travel?',
            answer: 'We offer a wide range of vehicles, including sedans, SUVs, and premium cars, all designed for comfort on long trips to Ganpatipule.',
          },
          {
            question: 'How do I pay for my Pune to Ganpatipule cab rental?',
            answer: 'We offer several payment options, including cash, credit/debit cards, and online payment via our app, making it convenient for you to settle your fare.',
          },
          {
            question: 'Can I book a round trip from Pune to Ganpatipule?',
            answer: 'Yes, we can arrange round trips. Simply provide us with your return details, and we’ll take care of the rest for a seamless experience.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'If any additional charges, such as for waiting or detours, apply, we will inform you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a taxi for sightseeing in Ganpatipule?',
            answer: 'Yes, we offer sightseeing tours in Ganpatipule. Explore the beautiful Ganpatipule Temple, the serene beach, and other local attractions with our knowledgeable drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Ganpatipule cab?',
            answer: 'Our vehicles can accommodate standard luggage easily. If you have extra luggage or specific requirements, kindly inform us during the booking process, and we\'ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Ganpatipule?',
            answer: 'Yes, we offer corporate travel services for group trips or business-related visits to Ganpatipule, ensuring a comfortable and reliable service.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Ganpatipule travel?',
            answer: 'S9 Travels offers a combination of reliability, affordability, comfort, and professionalism. With experienced drivers, well-maintained vehicles, and transparent pricing, we guarantee a safe and pleasant trip every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sanjay Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“I booked a cab with S9 Travels for a trip to Ganpatipule. The ride was comfortable, and the driver was professional and friendly. I reached my destination on time and felt safe throughout the journey. Highly recommended!”',
        },
        {
          name: 'Mrs. Priya Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“Our family had a wonderful experience with S9 Travels on our trip to Ganpatipule. The vehicle was clean, spacious, and comfortable, and the driver was courteous and knowledgeable. We’ll definitely use their services again!”',
        },
      ];
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Ganpatipule Cab",
        "description": "Book Pune To Ganpatipule taxi, cab services, one-way taxi, round trip, luxury taxi, Efficient Taxi, car rental, and drop taxi services with S9 Travels. Affordable fares for Pune to Ganpatipule car rental and taxi booking, ensuring a comfortable and safe journey to your destination.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
      
      
      


    return (
        <div>
           <Helmet>
        <title>Book Pune To Ganpatipule Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Ganpatipule taxi, one-way taxi, round trip, luxury taxi, Efficient Taxi, and car rental services with S9 Travels. Reliable and affordable taxi fares for Pune to Ganpatipule drop taxi services. Enjoy a comfortable and safe ride with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default BookPunetoganpatipulecab;